import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

/**
 * Shown for any path the website doesn't have, so an unknown link gets a
 * message and a way home instead of a blank page.
 */
const NotFound = () => (
    <section id="not-found" className="py-5 bg-light">
        <Container className="text-center">
            <h1 className="text-primary mb-3">Page not found</h1>
            <p className="fs-5">
                {"We couldn't find the page you were looking for."}
            </p>
            <Link to="/" className="btn btn-primary mt-3">
                Back to the home page
            </Link>
        </Container>
    </section>
);

export default NotFound;
